<template>
  <div class="row m-0">
    <div class="col pl-0 mb-1">
      <div class="label wrap_text">Name</div>
      <input type="text" v-model="variation.name" class="form-control w-100">
    </div>
    <div class="col pr-0 mb-1">
      <div class="label wrap_text">Total Price</div>
      <input type="number" v-model="variation.price" class="form-control w-100">
    </div>
    <div class="col-auto pr-0 pt-4 mt-2 mb-1" @click="remove">
      <div class="material-icons pointer">remove_circle_outline</div>
    </div>
  </div>
</template>
<script>
// import Multiselect from 'vue-multiselect'
export default {
  name: 'ProductVariation',
  props: ['variation', 'index'],
  methods: {
    remove () {
      this.$emit('removeVariation', this.index)
    }
  }
}
</script>
<style scoped>

</style>
